import { render, staticRenderFns } from "./QuestionarioConoscitivo.vue?vue&type=template&id=2b083f5d&scoped=true"
import script from "./QuestionarioConoscitivo.vue?vue&type=script&lang=js"
export * from "./QuestionarioConoscitivo.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioConoscitivo.vue?vue&type=style&index=0&id=2b083f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b083f5d",
  null
  
)

export default component.exports